<template>
	<PreviewWrapper :loading="flags.isLoadingPreview">
		<PreviewHeader
			:title="componentState.previewHeader.title"
			:icon="componentState.previewHeader.icon"
			iconSize="large"
		/>
		<PreviewSubtitle
			class="my-2"
			:params="componentState.category"
		/>
		<PreviewStatus
			class="my-4"
			:color="componentState.previewStatus.color"
		>
			<ao-icon iconName="clock" />
			{{ componentState.previewStatus.title }}
		</PreviewStatus>
		<AoMapPreview
			v-if="isShowMapsPreview"
			class="mb-1"
			:loading="isLoadingMapsPreview"
			:geojsonData="mapsPreview"
		/>
		<ao-btn
			v-if="Object.keys(btnInfo).length"
			class="mb-4 w-100 ao-p1"
			color="primary"
			height="40"
			@click="onMoreInfo"
		>
			{{ componentState.btnTitle }}
		</ao-btn>
		<PreviewCollapse :title="componentState.information.title">
			<ao-groupbox>
				<div
					class="ao-p2-regular"
					v-html="componentState.information.text"
				/>
			</ao-groupbox>
		</PreviewCollapse>
	</PreviewWrapper>
</template>

<script setup>
import { PreviewWrapper, PreviewHeader, PreviewSubtitle, PreviewStatus, PreviewCollapse } from '@/components/ui/preview'

import { computed, ref, onMounted } from 'vue'

import AoMapPreview from '@/components/ui/AoMapPreview.vue'
import useMaps from '@/composables/data/useMaps'

import { useRouter } from 'vue-router'
import { getUndefinedRouterLink } from '@/helpers/routingHelper'

import { useI18n } from 'vue-i18n'
import useMoment from '@/composables/useMoment'

import useNotifications from '@/composables/data/useNotifications'
import useNotificationCategoriesAndTypes from '@/composables/staticData/useNotificationCategoriesAndTypes'

import { DEFAULT_PREVIEW_PROPS } from '@/config/preview/previewConfig'

const { t: $t } = useI18n()

const props = defineProps({
	...DEFAULT_PREVIEW_PROPS,
})

const { flags, notificationPreview, getNotificationPreview } = useNotifications()
const { notificationCategories, notificationTypes } = useNotificationCategoriesAndTypes()

const { mapsPreview, isShowMapsPreview, flags: mapsFlags, getMapsPreview } = useMaps()

const { formatDateTime } = useMoment()

// const colorStatus = { recommendation: 'green', info: 'blue', warning: 'orange', alert: 'red' }

const router = useRouter()

// const notificationCategory = reactive(notificationCategories.value?.[notificationTypes.value?.[notificationPreview.value.notification_type]?.category]?.title)

const componentState = computed(() => ({
	previewHeader: {
		title: notificationTypes.value?.[notificationPreview.value?.notification_type]?.title,
		icon: notificationTypes.value?.[notificationPreview.value?.notification_type]?.iconKey,
	},
	category: [
		{
			name: notificationCategories.value?.[
				notificationTypes.value?.[notificationPreview.value?.notification_type]?.category
			]?.title,
			icon: 'category',
		},
	],
	previewStatus: {
		title: formatDateTime(notificationPreview.value?.created_at, 'HH:mm:ss DD.MM.YYYY', true),
		color: 'green',
	},
	btnTitle: $t('Detailed'),
	information: {
		title: $t('Content').toUpperCase(),
		text: notificationPreview.value?.content,
	},
}))

const btnInfo = ref(notificationPreview.value?.action_info || {})

const isLoadingMapsPreview = computed(() => mapsFlags.isLoadingMapPreview)

const dataLoaded = ref(false)

function onMoreInfo() {
	const routerData = router.resolve(getUndefinedRouterLink(notificationPreview.value.action_info))
	return window.open(routerData.href, '_blank')
}

const loadData = async () => {
	dataLoaded.value = false
	await getNotificationPreview(props.entityId)
	getMapsPreview(notificationPreview.value.map_info)

	dataLoaded.value = true
}

const updateNotification = async () => {
	await loadData()
}

onMounted(() => {
	loadData()
})

defineExpose({
	updateNotification,
})
</script>
